import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {OrderService} from "../../order/order.service";
import {OrderWorkflowService} from "./order-workflow.service";
import {ConfirmDialogService} from "../../confirm-dialog/confirm-dialog-service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {toggleLoading} from "../../misc/loading.decorator";
import {OrderFormGqlModel} from "../../order/order-form.gql-model";

@Component({
  templateUrl: "./confirm-order.template.pug",
  providers: [OrderService, OrderWorkflowService, ConfirmDialogService],
})
export class ConfirmOrderComponent extends WorkflowStep {
  error: Error;

  canEdit: boolean;
  sent: boolean = false;
  orderForm: OrderFormGqlModel = new OrderFormGqlModel({});

  editableFields: {[key: string]: boolean} = {
    deliveryContact: false,
    installationContact: false,
    siteAddress: false,
    alternateAddress: false,
    configurationAddress: false,
    shippingDestination: false,
    deliveryMethod: false,
    shipCompleted: false,
    floorLevel: false,
    resellerInformation: false,
    resellerInstructions: false,
    sourceDocumentationLink: false,
    deliveryInformation: false,
    orderNotificationEmailList: false,
    targetDeliveryDate: false,
    estimatedDeliveryDate: false,
    estimatedHardwareOrderDate: false,
    requestedDeliveryDate: false,
  };

  @toggleLoading()
  @handleErrors()
  async ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    const orderRequested = this.workflowService.workflowConfig.target["orderRequested"];

    this.canEdit = !orderRequested;

    if (this.canEdit && !this.isLocked) {
      Object.keys(this.editableFields).forEach((field) => { this.editableFields[field] = true; });
    }

    this.orderForm = await this.orderService.getOrderForm(workflowTargetInfo.targetId);
  }

  @handleErrors()
  async autoSave(): Promise<boolean> {
    if (!this.orderForm.header.orderAcceptanceCompleted) {
      return false;
    }

    await this.orderService.confirmOrderForm(this.workflowTargetInfo.targetId);

    await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);

    return true;
  }

  @handleErrors()
  async notifyOrderAcceptance() {
    const result = await this.confirmDialogService.confirm(
      "Confirm",
      "Send notification to the contract administrator?",
    );

    if (result) {
      await this.orderWorkflowService.notifyOrderAcceptance(this.workflowTargetInfo.targetId);

      this.sent = true;
    }
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public orderService: OrderService,
    public orderWorkflowService: OrderWorkflowService,
    private confirmDialogService: ConfirmDialogService,
  ) {
    super(true);
    this.saveOnContinue = true;
  }
}
